import { gx } from "@/components/gtax/base";
import { Link } from "react-router-dom";

export const Prose = ({ eyebrow, title, paras, ivory, id, aside }) => (
  <section className={`py-24 gx-line ${ivory ? "gx-ivory" : ""}`} data-testid={`gtax-prose-${id}`}>
    <div className="gx-wrap grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <p className="gx-eyebrow">{eyebrow}</p>
        <h2 className="gx-serif text-3xl md:text-4xl mt-5 leading-tight">{title}</h2>
        {aside}
      </div>
      <div className="lg:col-span-8 space-y-6 text-[color:var(--mute)] leading-[1.85] text-[17px]">
        {paras.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}
      </div>
    </div>
  </section>
);

export const FACTS = [
  ["Programme", "GTA X — Gold Trading Association"],
  ["Sponsor", "DFI Holdings · Abu Dhabi, United Arab Emirates"],
  ["Instrument", "Spot gold, XAU/USD only"],
  ["Execution broker", "VT Markets Limited · FSC Mauritius, licence GB23202269"],
  ["Structure", "Single consolidated discretionary mandate, member ledger per member"],
  ["Settlement", "USDT / USDC to the GTA X Consolidated Treasury, released after approval"],
  ["Member agreement", "Written Membership Agreement, digitally signed, PDF copy to every member"],
  ["Reporting", "Member ledger, periodic statements, verifiable trading record"],
  ["Governing law", "Abu Dhabi Global Market (ADGM)"],
  ["Access", "Invitation only · identity-verified members"],
  ["Contact", "support@gta-x.io"],
];

export const Facts = ({ title = "The programme at a glance." }) => (
  <section className="py-24 gx-line gx-ivory" data-testid="gtax-facts">
    <div className="gx-wrap grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <p className="gx-eyebrow">Key facts</p>
        <h2 className="gx-serif text-3xl md:text-4xl mt-5 leading-tight">{title}</h2>
        <p className="mt-6 text-[color:var(--mute)] leading-relaxed">Clear structure, named counterparties and written terms. Read the <Link to={gx("/terms")} className="underline">Membership Agreement</Link> and <Link to={gx("/risk")} className="underline">Risk Disclosure</Link> before requesting access.</p>
      </div>
      <dl className="lg:col-span-8 border-t border-[color:var(--line)]">
        {FACTS.map(([k, v]) => (
          <div key={k} className="grid sm:grid-cols-[220px_1fr] gap-2 sm:gap-8 py-5 border-b border-[color:var(--line)]" data-testid={`gtax-fact-${k.toLowerCase().replace(/\s+/g, "-")}`}>
            <dt className="text-xs uppercase tracking-[.2em] font-semibold text-[color:var(--gold)]">{k}</dt>
            <dd className="text-[color:var(--ink)]">{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  </section>
);

export const Steps = ({ eyebrow, title, steps, id }) => (
  <section className="py-24 gx-line" data-testid={`gtax-steps-${id}`}>
    <div className="gx-wrap">
      <p className="gx-eyebrow">{eyebrow}</p>
      <h2 className="gx-serif text-3xl md:text-4xl mt-5 max-w-3xl leading-tight">{title}</h2>
      <ol className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[color:var(--line)] border border-[color:var(--line)]">
        {steps.map(([h, p], i) => (
          <li key={h} className="bg-[color:var(--bg)] p-8">
            <div className="gx-serif text-3xl gx-gold">{String(i + 1).padStart(2, "0")}</div>
            <h3 className="gx-caps text-lg mt-4">{h}</h3>
            <p className="mt-3 text-[color:var(--mute)] leading-relaxed">{p}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export const Faq = ({ items }) => (
  <section className="py-24 gx-line" data-testid="gtax-faq">
    <div className="gx-wrap grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4"><p className="gx-eyebrow">Questions</p><h2 className="gx-serif text-3xl md:text-4xl mt-5">Frequently asked.</h2></div>
      <div className="lg:col-span-8 border-t border-[color:var(--line)]">
        {items.map(([q, a], i) => (
          <details key={q} className="py-6 border-b border-[color:var(--line)] group" data-testid={`gtax-faq-${i}`}>
            <summary className="cursor-pointer list-none flex justify-between gap-6 gx-serif text-xl md:text-2xl">{q}<span className="gx-gold group-open:rotate-45 transition-transform">+</span></summary>
            <p className="mt-4 text-[color:var(--mute)] leading-[1.8]">{a}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);
